import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { UnnamedSegment } from '@fullstory/proto/fs/services/dx-objects';
import { hashObject } from '@fullstory/util/hash';

export const hashForUnnamedSegment = (
  segmentDefinition: SegmentDefinition,
  disabled: UnnamedSegment.Disabled,
  name: string,
  description: string,
): number =>
  hashObject({
    segmentDefinition,
    disabled,
    name,
    description,
  });
